import {
  getImportSummaryCellStyle,
} from '@bingads-webui-campaign-react/imports-shared-styles';
import {
  convertToLocalStyle,
} from '@bingads-webui-campaign-react/common-styles';
import { getImportCalloutStyles } from './import-callout-styles';

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export const getLogsGridStyle = ({ palette = {} }) => ({
  ...getImportSummaryCellStyle(),
  ...convertToLocalStyle(getImportCalloutStyles({ palette })),

  '& colgroup': {
    '& .col-StartTime, & .col-ImportType': {
      width: '15%',
    },
    '& .col-Name, & .col-ImportSettings, & .col-summary': {
      width: '20%',
    },
    '& .col-Error': {
      width: '10%',
    },
  },

  '& tbody>tr>td': {
    '& p.child-account-task, & p.child-batch': {
      marginLeft: '10%',
    },

    '& p.child-batch.child-account-task': {
      marginLeft: '20%',
    },
  },

  '& .col-Name p': {
    wordBreak: 'break-word',
  },
});
